// Module
var code = "<script>let $ctrl</script> <button class=\"button button--deactivate\" type=\"button\" title=\"{{ 'dfd549cf-ddd7-4203-9eeb-e43fc4a69856' | translate }}\" ng-click=\"$ctrl.deactivate()\" ng-disabled=\"$ctrl.disabled\" name=\"button-deactivate\"> <atom-text class=\"button__text\"> <ng-transclude></ng-transclude> </atom-text> </button> ";
// Exports
module.exports = code;